<script setup lang="ts">
import type { WhatIsRelation } from "~/types/article"

defineProps<{
  note: WhatIsRelation
}>()
</script>

<template>
  <USidenote :note="note" title-class="text-[--theme-darker]">
    <template #content>
      <URichText
        class="!font-national2 !text-mobile-sidenote-p1 lg:!text-desktop-sidenote-p1"
        :html="note.resource.explanation"
      />
    </template>
  </USidenote>
</template>
